import { createContext, FC, useContext } from 'react';
import { noop } from 'lodash';
// Import Types
import type { CJPagesProps } from 'types';
// Import Enums
import { PageTypesEnum } from 'enums';
// Import Constants
import { RealtimePromotionTypes } from 'constants/common';

const CJ_CONFIG_INITIAL_VALUE: CJPagesProps = {
    pageMode: PageTypesEnum.create,
    titleKey: '',
    setIsDisabledDownload: noop,
    promotionType: RealtimePromotionTypes.CustomerJourney,
};

const CJConfigContext = createContext<CJPagesProps>(CJ_CONFIG_INITIAL_VALUE);

export const CJConfigProvider: FC<Partial<CJPagesProps>> = (props) => {
    const {
        children,
        titleKey = '',
        pageMode = PageTypesEnum.create,
        setIsDisabledDownload = noop,
        promotionType = RealtimePromotionTypes.CustomerJourney,
        ...restProps
    } = props;
    return (
        <CJConfigContext.Provider value={{ titleKey, pageMode, setIsDisabledDownload, promotionType, ...restProps }}>
            {children}
        </CJConfigContext.Provider>
    );
};

export const useCJConfig = () => {
    const context = useContext(CJConfigContext);
    if (!context) throw new Error('useCJConfig must be used within a CJConfigProvider');
    return context;
};
